export enum SignInSectionTypes {
  SIGN_IN_USER_FORM = 'SIGN_IN_FORM',
  PLAYER_PARAMETER_FORM = 'PLAYER_PARAMETER_FORM',
  VERIFICATION_FORM = 'VERIFICATION_FORM',
  SIGN_UP_COMPLETE = 'SIGN_UP_COMPLETE',
  SIGN_IN_UUID_FORM = 'SIGN_IN_UUID_FORM',
}
